import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Centipoise: ConvertableUnit = {
  label: "Centipoise",
  toStandardUnit: centipoise => centipoise,
  toThisUnit: centipoise => centipoise
};

export const PoundsPerFootSecond: ConvertableUnit = {
  label: "lb/ft/s",
  toStandardUnit: lbfts => lbfts / 0.000671969,
  toThisUnit: centipoise => centipoise * 0.000671969
};

const unitList = [Centipoise, PoundsPerFootSecond];
export const ViscosityUnits = {
  Centipoise,
  PoundsPerFootSecond,
  options: buildOptions(unitList)
};
